import { createApiInstance } from "./apiInstance";
import { apiCall } from "./apiCall";
import { Method } from "axios";

const merchantApi = createApiInstance(process.env.REACT_APP_SERVER_BASE_URL || "https://onepay-merchant.onepayapi.lk/v3/");

export const merchantApiCall = (
  url: string,
  method: Method = 'GET',
  data: any = null,
  header: string | null = null,
  encrypt: boolean = false,
): Promise<any> => {
  return apiCall(merchantApi, url, method, data, header, encrypt,false);
};
